import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Orders.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate, useParams } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import Spinner from "../components/CTA/Spinner";
import { getEuroCentToEuro } from "../functions/getEuroCentToEuro";

export default function Order({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  companyData,
  orders,
  reload,
  setReload,
  payouts,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;
  const { orderid } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [orderData, setOrderData] = useState({});
  const [isSeller, setIsSeller] = useState(false);
  const [fulfillment_delivery_url, setFulfillment_delivery_url] = useState("");
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [file, setFile] = useState(null); // Store the downloaded file for sharing
  const [hasPayout, setHasPayout] = useState(false);

  useEffect(() => {
    if (!isEmpty(orders)) {
      setIsLoading(false);

      orders.map((order) => {
        if (order.id == orderid) {
          setOrderData(order);
          setFulfillment_delivery_url(order.fulfillment_deliveryurl);
        }
      });
    }

    if (!isEmpty(companyData) && !isEmpty(orderData)) {
      if (companyData.id == orderData.seller_id) {
        setIsSeller(true);
      } else {
        setIsSeller(false);
      }
    }
  }, [orderid, companyData, orders, orderData]);

  useEffect(() => {
    if (!isEmpty(payouts)) {
      let payoutfound = false;
      payouts.map((payout) => {
        if (payout.order_id == orderid) {
          payoutfound = true;
        }
      });

      if (payoutfound) {
        setHasPayout(true);
      } else {
        setHasPayout(false);
      }
    }
  }, [payouts]);

  const handleDownload = async () => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", orderData.fulfillment_mergedfile_url, true);
      xhr.responseType = "blob";

      xhr.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentComplete = (event.loaded / event.total) * 100;
          setDownloadProgress(percentComplete);
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          const blob = xhr.response;

          // Create a File instance for sharing (if supported)
          const file = new File([blob], "video.mp4", { type: "video/mp4" });
          setFile(file); // Store the file for later use

          // Handle automatic download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "video.mp4";

          // Append link to the DOM, trigger the download, and clean up
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Revoke object URL to free memory
          URL.revokeObjectURL(link.href);
        } else {
          console.error("Error downloading the video. Status:", xhr.status);
        }
      };

      xhr.onerror = function () {
        console.error("Error during the file download process.");
      };

      xhr.send();
    } catch (error) {
      console.error("Error in the download function:", error);
    }
  };

  const handleShare = async () => {
    if (
      file &&
      navigator.canShare &&
      navigator.canShare({ files: [file] }) &&
      isIOS()
    ) {
      try {
        await navigator.share({
          title: "Mein letsfluence Video",
          text: "Auf Insta teilen",
          files: [file],
        });
      } catch (error) {
        console.error("Error sharing the file:", error);
      }
    }
  };

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  const fulfillDeliveryURL = async () => {
    setIsLoading(true);
    const resa = await fetch(`${apiURL}/api/orders/index.php?id=` + orderid, {
      method: "POST",
      headers: {
        //   Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        fulfillment_deliveryurl: fulfillment_delivery_url,
      }),
    });

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = () => {
    setReload(!reload);
  };

  function openStoryPost() {
    let instagramLink = orderData.fulfillment_deliveryurl;
    // Detect if the device is a phone
    const isPhone = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isPhone) {
      // Try to open in the Instagram app using deep linking
      const deepLink = instagramLink.replace(
        "https://www.instagram.com",
        "instagram://user"
      );
      window.location.href = deepLink;

      // Fallback: Open in the browser after a short delay if the app is not installed
      setTimeout(() => {
        window.location.href = instagramLink;
      }, 1000); // Adjust delay as needed
    } else {
      // Open in the browser for non-phone devices
      window.open(instagramLink, "_blank");
    }
  }

  return (
    <div className="orders">
      {isMobile ? (
        <div className="orders_topnav">
          <div
            className="orders_topnav_back"
            onClick={() =>
              isSeller ? navigate("/seller") : navigate("/orders")
            }>
            <ArrowBack />
          </div>
          <div
            className="orders_topnav_back_text"
            onClick={() =>
              isSeller ? navigate("/seller") : navigate("/orders")
            }>
            Bestellung Nr {orderid}
          </div>
        </div>
      ) : (
        <div className="orders_topnav">
          <div
            className="orders_topnav_left_title"
            onClick={() =>
              isSeller ? navigate("/seller") : navigate("/orders")
            }>
            <ArrowBackDesktop />
            Bestellung Nr {orderid}
          </div>
        </div>
      )}

      <div className="orders_body">
        {isSeller ? (
          <div className="orders_body_fulfill">
            <div className="orders_body_fulfill_row">
              <div className="orders_body_fulfill_row_count">1.</div>
              <div className="orders_body_fulfill_row_task">
                {isEmpty(orderData.fulfillment_mergedfile_url) ? (
                  <div className="order_body_fulfill_row_task_downloadbutton">
                    Video wird vorbereitet <Spinner />
                  </div>
                ) : (
                  <>
                    {file && isIOS() ? (
                      <div
                        className="order_body_fulfill_row_task_downloadbutton"
                        onClick={() => handleShare()}>
                        Bereit zum Speichern oder Teilen
                      </div>
                    ) : (
                      <div
                        className="order_body_fulfill_row_task_downloadbutton"
                        onClick={() => handleDownload()}>
                        Download
                        {isIOS() && downloadProgress > 0 && (
                          <progress
                            className="order_body_fulfill_row_task_downloadbutton_progress"
                            value={downloadProgress}
                            max="100"></progress>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="orders_body_fulfill_row">
              <div className="orders_body_fulfill_row_count">2.</div>
              <div className="orders_body_fulfill_row_task">
                <div className="order_body_fulfill_row_task_text">
                  Auf Instagram Stories teilen und den Link speichern
                </div>{" "}
              </div>
            </div>
            <div className="orders_body_fulfill_row">
              <div className="orders_body_fulfill_row_count">3.</div>
              <div className="orders_body_fulfill_row_task">
                <input
                  value={fulfillment_delivery_url}
                  onChange={(e) => setFulfillment_delivery_url(e.target.value)}
                  placeholder="Link zum Teilen deiner hochgeladenen Story hier einfügen"
                  className="orders_body_fulfill_row_task_input"
                />
              </div>
            </div>
            {isLoading ? (
              <div className="order_body_fulfill_cta">
                <Spinner type="white" />
              </div>
            ) : (
              <>
                {!isEmpty(orderData) &&
                orderData.fulfillment_deliveryurl !=
                  fulfillment_delivery_url ? (
                  <div
                    className="order_body_fulfill_cta"
                    onClick={() => fulfillDeliveryURL()}>
                    Auftrag beenden Speichern
                  </div>
                ) : (
                  <>
                    {!isEmpty(orderData) &&
                    isEmpty(orderData.fulfillment_deliveryurl) ? (
                      <div
                        className="order_body_fulfill_ctaDisabled"
                        onClick={() => fulfillDeliveryURL()}>
                        URL einfügen um abzuschließen
                      </div>
                    ) : (
                      <div
                        className="order_body_fulfill_ctaDisabled"
                        onClick={() => fulfillDeliveryURL()}>
                        Auftrag abgeschlossen
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            <div className="order_body_payoutpreview">
              <div className="order_body_payoutpreview_title">
                Dein Verdienst: {getEuroCentToEuro(orderData.seller_price)}
              </div>

              {hasPayout ? (
                <>
                  <div className="order_body_payoutpreview_text">
                    Auszahlung ist auf dem Weg und dauert herkömmliche
                    Bankarbeitstage
                  </div>
                </>
              ) : (
                <>
                  <div className="order_body_payoutpreview_text">
                    Wenn du den Auftrag abgeschlossen hast, kannst du hier deine
                    Auszahlung beantragen.
                  </div>
                  {isEmpty(orderData.fulfillment_deliveryurl) ? (
                    <div className="order_body_payoutpreview_ctaDisabled">
                      Auftrag abschließen um auszuzahlen
                    </div>
                  ) : (
                    <div
                      className="order_body_payoutpreview_cta"
                      onClick={() => navigate("/payout/" + orderid)}>
                      Zur Auszahlung
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="orders_body_buyersview">
            {isEmpty(orderData.fulfillment_deliveryurl) ? (
              <div className="orders_body_buyersview_headline">
                Deine Bestellung ist in bearbeitung
              </div>
            ) : (
              <>
                <div className="orders_body_buyersview_headline">
                  Deine Bestellung ist live!
                </div>
                <div
                  className="orders_body_buyersview_cta"
                  onClick={() => openStoryPost()}>
                  Storypost öffnen
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;
const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
